export default "__VITE_ASSET__2214167c__"